<div>
  <h1 class="mt-3 mb-3" style="height: 7%">Inventory
    <div class="d-flex float-right mt-4 mr-3">
      <button class="btn p-0 text-muted" (click)="addItem()">Add Item +</button>
    </div>
  </h1>
</div>
<hr>
<div class="mt-3 mb-3">
  <form *ngIf="moneyForm" [formGroup]="moneyForm" class="d-flex">
    <span class="my-auto mr-1 font-weight-bold">P:</span>
    <input id="platinumInput" type="text" class="form-control money" #platinum formControlName="platinum"
           (keyup.enter)="$event.target.blur()" (focus)="platinum.value=''" (focusout)="updateMoney()"
           placeholder="{{moneyForm.get('platinum').value}}">

    <span class="my-auto mr-1 ml-2 font-weight-bold">G:</span>
    <input id="goldInput" type="text" name="gold" class="form-control money" #gold formControlName="gold"
           (keyup.enter)="$event.target.blur()" (focus)="gold.value=''" (focusout)="updateMoney()"
           placeholder="{{inventory.gold}}">

    <span class="my-auto mr-1 ml-2 font-weight-bold">S:</span>
    <input id="silverInput" type="text" name="silver" class="form-control money" #silver formControlName="silver"
           (keyup.enter)="$event.target.blur()" (focus)="silver.value=''" (focusout)="updateMoney()"
           placeholder="{{inventory.silver}}">

    <span class="my-auto mr-1 ml-2 font-weight-bold">C:</span>
    <input id="copperInput" type="text" name="copper" class="form-control money" #copper formControlName="copper"
           (keyup.enter)="$event.target.blur()" (focus)="copper.value=''" (focusout)="updateMoney()"
           placeholder="{{inventory.copper}}">
  </form>
</div>
<mat-tab-group mat-align-tabs="center" [disableRipple]="true" (selectedTabChange)="changeTab($event)"
               class="border-top">
  <mat-tab label="Items">
    <div *ngIf="items?.length > 0" class="item no-scrollbar p-2">
      <app-item [items]="items" (itemEmitter)="updateItemQuantity($event, 'item')" (editedItem)="editItem($event, 'item')"
                (deletedItem)="deleteItem($event, 'item')"></app-item>
    </div>
  </mat-tab>
  <mat-tab label="Weapons">
    <div *ngIf="weapons?.length > 0" class="item no-scrollbar p-2">
      <app-item [items]="weapons" (itemEmitter)="updateItemQuantity($event, 'weapon')" (editedItem)="editItem($event, 'weapon')"
                (deletedItem)="deleteItem($event, 'weapon')"></app-item>
    </div>
  </mat-tab>
</mat-tab-group>
